// Type definitions
interface PriceBracket {
    count: number;
    price: number;
}

export default function CalculatePrice(domainCount: number): number {

    // pre may 2025
/*
    let priceBrakets = [
        {count: 0,  price: 0},
        {count: 100,  price: 50},
        {count: 500,  price: 80},
        {count: 1000, price: 100},
        {count: 2000, price: 120},
        {count: 6000, price: 150},
        {count: 20000, price: 200},
        {count: 80000, price: 280},
        {count: 100000, price: 300},
        {count: 500000, price: 500} 
    ];
*/
    const priceBrakets: PriceBracket[] = [
        {count: 0,  price: 0},
        {count: 100,  price: 50},
        {count: 500,  price: 80},
        {count: 1000, price: 100},
        {count: 2000, price: 110},
        {count: 10000, price: 130},
        {count: 20000, price: 150},
        {count: 100000, price: 200},
        {count: 500000, price: 400} 
    ];


    let total: number = 0;

    if (domainCount == 0) return 0;
    if (domainCount > priceBrakets[priceBrakets.length-1].count) {
        return priceBrakets[priceBrakets.length-1].price;
    }

    let largerBraketCount: number = 0;
    let largerBraketPrice: number = 0;
    for (let i = priceBrakets.length - 1; i >= 0; i --) {
         if (domainCount < priceBrakets[i].count) {
            largerBraketCount = priceBrakets[i].count;
            largerBraketPrice = priceBrakets[i].price;
            continue;
        } if (domainCount == priceBrakets[i].count) {
            return enforceMinPrice(priceBrakets[i].price);
        }
        else {
            let reminder: number = 0;

            total = priceBrakets[i].price;
            reminder = domainCount - priceBrakets[i].count;

            total += reminder * (largerBraketPrice - priceBrakets[i].price)/
             (largerBraketCount - priceBrakets[i].count) ;
            return enforceMinPrice(Math.floor(total));
        }
    }
    // ??
    return 0;
}

function enforceMinPrice(price: number): number
{    
    const minPrice: number = 30;
    return (price < minPrice)  ? minPrice : price;
}